
import { AirmarAnalyticsSettingsApiModel, getAirmarAnalyticsSettings } from "@aus/Services/AirmarSystemSettingsService";
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";

type HandlerType = ApiHandler<ApiParameter, AirmarAnalyticsSettingsApiModel>;

export const DispatchBeginLoadAirmarAnalyticsSettings: HandlerType = props => {
    props.dispatch({
        type: "Custom/AirmarAnalyticsSettings/BeginLoad",
    });
};

export const RequestAirmarAnalyticsSettings: HandlerType = async props => {
    props.apiResult = await getAirmarAnalyticsSettings(props.parameter);
};

export const DispatchCompleteLoadAirmarAnalyticsSettings: HandlerType = props => {
    props.dispatch({
        type: "Custom/AirmarAnalyticsSettings/CompleteLoad",
        result: props.apiResult,
    });
};

export const chain = [
    DispatchBeginLoadAirmarAnalyticsSettings,
    RequestAirmarAnalyticsSettings,
    DispatchCompleteLoadAirmarAnalyticsSettings,
];

const loadAirmarAnalyticsSettings = createHandlerChainRunner(chain, "LoadAirmarAnalyticsSettings");

export default loadAirmarAnalyticsSettings;